import { render, staticRenderFns } from "./transferServiceForSecureUpgrade.vue?vue&type=template&id=7dab8d6c&scoped=true&"
import script from "./transferServiceForSecureUpgrade.vue?vue&type=script&lang=tsx&"
export * from "./transferServiceForSecureUpgrade.vue?vue&type=script&lang=tsx&"
import style0 from "./transferServiceForSecureUpgrade.vue?vue&type=style&index=0&id=7dab8d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab8d6c",
  null
  
)

export default component.exports